module.exports = __webpack_public_path__ + "static/media/rental-image.8d14e7d3.jpg";